import { Outlet } from 'react-router';
import { Layout } from '@arco-design/web-react';

// 认证布局（登录/注册页使用）
export function AuthLayout() {
  return (
    <Layout style={{ minHeight: '100vh', background: 'var(--color-bg-1)' }}>
      <Layout.Content
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          padding: 24,
        }}
      >
        <div style={{ width: '100%', maxWidth: 400 }}>
          <div style={{ textAlign: 'center', marginBottom: 32 }}>
            <h1 style={{ fontSize: 28, fontWeight: 700, color: 'var(--color-text-1)' }}>Pingo</h1>
            <p style={{ color: 'var(--color-text-3)', marginTop: 8 }}>开发者后台</p>
          </div>
          <Outlet />
        </div>
      </Layout.Content>
    </Layout>
  );
}
